export default __webpack_public_path__ + "static/gitkraken_setting_light-06d93afac58835da36128a5ffdaed54b.png";